/**
 * External Dependencies
*/
import 'jquery';
import AOS from 'aos';
 
const scrollHeader = () => {
  var lastScrollTop = 0;
  var backToTop = 0;
  $(window).on('scroll', function(e) {
    // console.log('Hide header');
    var currentPos = $(window).scrollTop();


    // artist links
    if ($('body.single-taiteilija').length) {
      var artist_links = $('.single-artist-links-container').offset().top;
      if ($('#bio').length) {
        var bio_top = $('#bio').offset().top;
        var bio_bottom = $('#bio').offset().top + $('#bio').outerHeight(true);
      }
      if ($('#text_cv').length) {
        var cv_top = $('#text_cv').offset().top;
        var cv_bottom = $('#text_cv').offset().top + $('#text_cv').outerHeight(true);
      }
      if ($('#exhibition').length) {
        var exhibition_top = $('#exhibition').offset().top;
        var exhibition_bottom = $('#exhibition').offset().top + $('#exhibition').outerHeight(true);
      }
      if ($('#shop').length) {
        var shop_top = $('#shop').offset().top;
        var shop_bottom = $('#shop').offset().top + $('#shop').outerHeight(true);
      }
      if ($('#installation-view').length) {
        var installation_top = $('#installation-view').offset().top;
        var installation_bottom = $('#installation-view').offset().top + $('#installation-view').outerHeight(true);
      }
      if ($('#single-taiteilija-video').length) {
        var video_top = $('#single-taiteilija-video').offset().top;
        var video_bottom = $('#single-taiteilija-video').offset().top + $('#single-taiteilija-video').outerHeight(true);
      }

  
      if ( currentPos >= artist_links ) {
        $('.single-artist-links-container').addClass('sticky');
      } else {
        $('.single-artist-links-container').removeClass('sticky');
      }
  
      if (currentPos + 100 >= bio_top && currentPos + 100 <= bio_bottom && !(currentPos + 100 >= cv_top && currentPos <= cv_bottom)) {
        $('#bio_link').addClass('current');
      } else {
        $('#bio_link').removeClass('current');
      }

      if (currentPos + 100 >= cv_top && currentPos + 100 <= cv_bottom) {
        $('#cv_link').addClass('current');
      } else {
        $('#cv_link').removeClass('current');
      }
  
      if (currentPos + 100 >= exhibition_top && currentPos + 100 <= exhibition_bottom) {
        $('#exhibition_link').addClass('current');
      } else {
        $('#exhibition_link').removeClass('current');
      }

      if (currentPos + 100 >= installation_top && currentPos + 100 <= installation_bottom) {
        $('#installation_view_link').addClass('current');
      } else {
        $('#installation_view_link').removeClass('current');
      }

      if (currentPos + 100 >= video_top && currentPos + 100 <= video_bottom) {
        $('#video_link').addClass('current');
      } else {
        $('#video_link').removeClass('current');
      }
  
      if (currentPos + 100 >= shop_top && currentPos + 100 <= shop_bottom) {
        $('#shop_link').addClass('current');
      } else {
        $('#shop_link').removeClass('current');
      }
    }

    // artists links ends

    // exhibition links
    if ($('body.single-nayttely').length) {      
      var exhibition_links = $('.single-exhibition-links-container').offset().top;
  
      if ($('#info').length) {        
        var info_top = $('#info').offset().top;
        var info_bottom = $('#info').offset().top + $('#info').outerHeight(true);
      }
      if ($('#exhi_shop').length) {        
        var exhi_shop_top = $('#exhi_shop').offset().top;
        var exhi_shop_bottom = $('#exhi_shop').offset().top + $('#exhi_shop').outerHeight(true);
      }
      if ($('#installation-view').length) {        
        var installation_top = $('#installation-view').offset().top;
        var installation_bottom = $('#installation-view').offset().top + $('#installation-view').outerHeight(true);
      }
      if ($('#single-taiteilija-video').length) {        
        var video_top = $('#single-taiteilija-video').offset().top;
        var video_bottom = $('#single-taiteilija-video').offset().top + $('#single-taiteilija-video').outerHeight(true);
      }

      if ( currentPos >= exhibition_links ) {
        $('.single-exhibition-links-container').addClass('sticky');
      } else {
        $('.single-exhibition-links-container').removeClass('sticky');
      }

      if (currentPos + 100 >= info_top && currentPos + 100 <= info_bottom) {
        $('#info_link').addClass('current');
      } else {
        $('#info_link').removeClass('current');
      }
      if (currentPos + 100 >= exhi_shop_top && currentPos + 100 <= exhi_shop_bottom) {
        $('#exhi_shop_link').addClass('current');
      } else {
        $('#exhi_shop_link').removeClass('current');
      }
      if (currentPos + 100 >= installation_top && currentPos + 100 <= installation_bottom) {
        $('#installation_view_link').addClass('current');
      } else {
        $('#installation_view_link').removeClass('current');
      }
      if (currentPos + 100 >= video_top && currentPos + 100 <= video_bottom) {
        $('#video_link').addClass('current');
      } else {
        $('#video_link').removeClass('current');
      }
    }

    // exhibition links ends

    var banner = $('.banner');
    var bannerHeight = $(banner).outerHeight(true);


    if((currentPos > lastScrollTop) && (currentPos > bannerHeight)) {
      $('.banner').addClass('banner__hidden');
      $('.banner').addClass('banner__flyout');
      backToTop = currentPos;
    } else {
      if (backToTop > currentPos+500) {
        $('.banner').removeClass('banner__hidden');
      }
      if ((currentPos > 0)) {
        $('.banner').addClass('banner__flyout');
      } else {
        $('.banner').removeClass('banner__flyout');
        $('.banner').removeClass('banner__hidden');
      }
    }
    lastScrollTop = currentPos;

    e.stopImmediatePropagation();
    AOS.refresh();
  });
}

$(window).load(function() {
  AOS.init();

  scrollHeader();
});